import * as types from '../types/reviewTypes';
import { USE_API } from '../../config/env';
import {
  getProductReviews,
  getReviewsOverview,
  postProductReview,
} from '../../services/reviewService';

function slugKey(slugOrId) {
  return String(slugOrId || '').trim().toLowerCase();
}

export const fetchProductReviewsForProduct = (slugOrId) => async (dispatch) => {
  if (!USE_API) return;
  const key = String(slugOrId || '').trim();
  if (!key) return;
  dispatch({ type: types.FETCH_PRODUCT_REVIEWS_REQUEST, payload: { slug: key } });
  try {
    const { reviews, summary } = await getProductReviews(key);
    const sum =
      summary ?? {
        average: 0,
        count: 0,
        distribution: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        recommendPercent: 0,
      };
    dispatch({
      type: types.FETCH_PRODUCT_REVIEWS_SUCCESS,
      payload: { slug: slugKey(key), reviews, summary: sum },
    });
  } catch (e) {
    dispatch({
      type: types.FETCH_PRODUCT_REVIEWS_FAILURE,
      payload: {
        slug: slugKey(key),
        message: e?.response?.data?.message || e?.message || 'Failed to load reviews',
      },
    });
  }
};

export const submitProductReviewThunk =
  ({ slugOrId, ...body }) =>
  async (dispatch, getState) => {
    if (!USE_API) return;
    const key = String(slugOrId || '').trim();
    if (!key) throw new Error('Missing product');
    if (!getState().auth?.token) throw new Error('Sign in to leave a review');
    try {
      await postProductReview(key, body);
      dispatch(fetchProductReviewsForProduct(key));
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'Could not submit review';
      throw new Error(msg);
    }
  };

export const fetchReviewsOverviewThunk = (limit = 24) => async (dispatch) => {
  if (!USE_API) return;
  dispatch({ type: types.FETCH_REVIEWS_OVERVIEW_REQUEST });
  try {
    const data = await getReviewsOverview(limit);
    dispatch({
      type: types.FETCH_REVIEWS_OVERVIEW_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.FETCH_REVIEWS_OVERVIEW_FAILURE,
      payload: e?.response?.data?.message || e?.message || 'Failed to load reviews',
    });
  }
};

export function selectReviewsForSlug(state, slugOrId) {
  const k = slugKey(slugOrId);
  return state.reviews?.bySlug?.[k] ?? { loading: false, error: null, reviews: [], summary: null };
}

export function selectReviewsOverview(state) {
  return state.reviews?.overview ?? {
    loading: false,
    error: null,
    summary: {},
    reviews: [],
  };
}
